import { Box, LinearProgress } from "@mui/material";
import Button, { ButtonProps } from "@mui/material/Button";
import { useCallback, useState } from "react";

export type LoadingButtonProps = ButtonProps & { loading?: boolean };
export default function LoadingButton(props: LoadingButtonProps) {
  const [loading, setLoading] = useState(false);

  const onClick = useCallback(
    async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      setLoading(true);
      try {
        if (props.onClick) await Promise.resolve(props.onClick(event));
      } finally {
        setLoading(false);
      }
    },
    [props]
  );

  const sxHeight =
    props.sx && !Array.isArray(props.sx) && typeof props.sx === "object"
      ? (props.sx as Record<string, unknown>).height
      : undefined;

  return (
    <Box
      position="relative"
      sx={{
        ...(props.fullWidth && { width: "100%" }),
        ...(sxHeight !== undefined && { height: sxHeight }),
      }}
    >
      <Button
        {...props}
        onClick={onClick}
        disabled={props.disabled || loading}
      />
      {(props.loading || loading) && (
        <LinearProgress
          color="primary"
          sx={{ position: "absolute", left: 0, bottom: 0, width: "100%" }}
        />
      )}
    </Box>
  );
}
